import ClientRepository from "@domain/repositories/ClientRepository";
import UseCase from "@domain/UseCase";
import { ClientExportData } from "@domain/models/ClientExportData";
import { Filter } from "@domain/models/Filters";
import { Client } from "@domain/models/Client";

type Input = {
  filters: Filter[];
  clientIds: Client["id"][];
};

type Output = Promise<ClientExportData[]>;

export class GetClientExportDataUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientRepository: ClientRepository) {}

  execute({ filters, clientIds }: Input) {
    return this.clientRepository.exportClients(filters, clientIds);
  }
}
